export default __webpack_public_path__ + "static/media/compiegne14.1e738095.jpg";